import React from 'react'
import {
  Divider,
  FormControl,
  InputLabel, LinearProgress,
  MenuItem,
  Select,
  TextField,
  Typography,
  Button,
} from "@material-ui/core";
import {BUSINESS_CATEGORIES} from "../../Views/Advertisers/Auth/constants";
import {Alert} from "@material-ui/lab";

import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  formControl: {
    margin: `${theme.spacing(2)}px 0`,
    minWidth: 400,
    maxWidth: 500,
    width: 400,
  },
}));


export default function AccountSettingsForm({formData, submitText, onChange, onSubmit, loading, errorMsg, success}) {
  const classes = useStyles();

  const fieldChange = e => {
    onChange(e, e.target.name);
  };

  return (
    <form className={classes.form} noValidate onSubmit={onSubmit}>
      <Typography variant="h5" gutterBottom>
        Personal Info
      </Typography>
      <Divider />
      <TextField
        variant="outlined"
        margin="normal"
        required
        fullWidth
        id="first_name"
        label="First Name"
        name="first_name"
        value={formData.first_name}
        onChange={fieldChange}
      />
      <TextField
        variant="outlined"
        margin="normal"
        required
        fullWidth
        id="last_name"
        label="Last Name"
        name="last_name"
        value={formData.last_name}
        onChange={fieldChange}
      />
      <TextField
        variant="outlined"
        margin="normal"
        required
        fullWidth
        id="phone_number"
        label="Phone Number"
        name="phone_number"
        value={formData.phone_number}
        onChange={fieldChange}
      />
      <p>&nbsp;</p>
      <Typography variant="h5" gutterBottom>
        Business Info
      </Typography>
      <Divider />
      <TextField
        variant="outlined"
        margin="normal"
        required
        fullWidth
        id="business_name"
        label="Business Name"
        name="business_name"
        value={formData.business_name}
        onChange={fieldChange}
      />
      <TextField
        variant="outlined"
        margin="normal"
        required
        fullWidth
        id="address1"
        label="Business Address"
        name="address1"
        value={formData.address1}
        onChange={fieldChange}
      />
      <TextField
        variant="outlined"
        margin="normal"
        required
        fullWidth
        id="address2"
        label="Business Suite Number"
        name="address2"
        value={formData.address2}
        onChange={fieldChange}
      />
      <TextField
        variant="outlined"
        margin="normal"
        required
        fullWidth
        id="city"
        label="Business City"
        name="city"
        value={formData.city}
        onChange={fieldChange}
      />
      <TextField
        variant="outlined"
        margin="normal"
        required
        fullWidth
        id="state"
        label="Business State"
        name="state"
        value={formData.state}
        onChange={fieldChange}
      />
      <TextField
        variant="outlined"
        margin="normal"
        required
        fullWidth
        id="zip"
        label="Business Zip"
        name="zip"
        value={formData.zip}
        onChange={fieldChange}
      />
      <FormControl className={classes.formControl}>
        <InputLabel id="business_category-field">Business Category</InputLabel>
        <Select
          labelId="business_category-field"
          id="business_category-label"
          name="business_category"
          value={formData.business_category}
          onChange={fieldChange}
        >
          {BUSINESS_CATEGORIES.map(option => (
            <MenuItem key={option} value={option}>{option}</MenuItem>
          ))}
        </Select>
      </FormControl>
      {loading && <LinearProgress />}
      {errorMsg && errorMsg.length > 0 && (
        <Alert severity="error">{errorMsg}</Alert>
      )}

      {success && (
        <Alert severity="success">Account information successfully updated</Alert>
      )}

      <Button
        type="submit"
        fullWidth
        variant="contained"
        color="primary"
        className={classes.submit}
      >
        {submitText}
      </Button>
    </form>
  )
}
